import WixSDK from 'shared/utils/wix-sdk';
import { BI_EVENT } from 'shared/bi/bi-handler';
import { getCompId } from 'shared/utils/comp-id';

export function sendBiEvent(eventName, params) {
  WixSDK.PubSub.publish(BI_EVENT, {
    eventName,
    params,
    targetCompId: getCompId(),
  });
}

export function withBiEvent(eventName, getParams = _.noop) {
  return function (target, name, descriptor) {
    const originalMethod = descriptor.value;

    descriptor.value = function wrappedMethod(...args) {
      sendBiEvent(eventName, getParams.apply(this, args));
      originalMethod.apply(this, args);
    };

    return descriptor;
  };
}



// WEBPACK FOOTER //
// ./src/shared/bi/send-bi-event.js